import { render, staticRenderFns } from "./swallowPrimitive.vue?vue&type=template&id=1460f9bf&scoped=true&"
import script from "./swallowPrimitive.vue?vue&type=script&lang=js&"
export * from "./swallowPrimitive.vue?vue&type=script&lang=js&"
import style0 from "./swallowPrimitive.vue?vue&type=style&index=0&id=1460f9bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460f9bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1460f9bf')) {
      api.createRecord('1460f9bf', component.options)
    } else {
      api.reload('1460f9bf', component.options)
    }
    module.hot.accept("./swallowPrimitive.vue?vue&type=template&id=1460f9bf&scoped=true&", function () {
      api.rerender('1460f9bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/swallowPrimitive.vue"
export default component.exports